import { formatCurrency, formatDisplayDate } from 'syf-js-utilities/formats';
import { paymentOptions } from '../../../const/paymentOptions';
import { t } from '../../../strings/i18n';
const getHasMatchingPayment = (paymentDate, paymentMethod, activity) => {
    const formattedPaymentDate = formatDisplayDate(paymentDate);
    return activity.some((item) => {
        const { paymentInfo, status, postedDate } = item;
        if (!(paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.id))
            return false;
        const formattedScheduledDate = formatDisplayDate(postedDate);
        const isAlreadyScheduled = formattedPaymentDate === formattedScheduledDate;
        const withSameMethod = paymentInfo.id === paymentMethod;
        return isAlreadyScheduled && withSameMethod && status !== 'CANCELED';
    });
};
const getPaymentAmountDisplay = (paymentOption, paymentAmount) => {
    if (!paymentOption) {
        return '';
    }
    const formattedPaymentAmount = formatCurrency(Number(paymentAmount));
    if (paymentOption === paymentOptions.OTHER_PAYMENT) {
        return formattedPaymentAmount;
    }
    const paymentAmountOption = t(`paymentAmountOptionText.${paymentOption}`);
    return `${formattedPaymentAmount} (${paymentAmountOption})`;
};
const getPayoffAmountDisplay = (paymentDate, paymentAmount) => {
    return `${formatDisplayDate(paymentDate)} (${formatCurrency(Number(paymentAmount))})`;
};
export { getHasMatchingPayment, getPaymentAmountDisplay, getPayoffAmountDisplay };
